import { Address, AddressApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AddressExtended } from '@/models/extensions';

export class AddressService {
	constructor(private addressApi: AddressApi = new AddressApi()) {}

	public async getAddressById<T extends Address>(
		id: number,
	): Promise<{ address?: T; errorMessage?: string }> {
		try {
			const response = await this.addressApi.getAddressById(id);
			return { address: <T>response.data };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to fetch address by id: ${id}`);
		}
	}

	public async addAddress(
		address: AddressExtended,
	): Promise<{ success?: boolean; errorMessage?: string }> {
		try {
			await this.addressApi.addAddress({
				data: {
					...address,
					// @ts-ignore
					rawAddress: address.rawAddress,
				},
			});
			return { success: true };
		} catch (e) {
			return ApiUtils.handleApiError(e, 'Failed to add address');
		}
	}

	public async updateAddress(
		address: AddressExtended,
	): Promise<{ success?: boolean; errorMessage?: string }> {
		if (address?.id == null)
			return { success: false, errorMessage: 'Failed to update address, no ID provided' };
		try {
			await this.addressApi.updateAddress(address.id, {
				// @ts-ignore because the api call requires rawAddress being a string, but the api
				// validation requires it to be an object. address.rawAddress is currently an object
				data: address,
			});
			return { success: true };
		} catch (e) {
			return ApiUtils.handleApiError(e, 'Failed to update address');
		}
	}

	public convertAddressToObject(address: Address | undefined): AddressExtended | undefined {
		if (!address) return undefined;
		return {
			...address,
			rawAddress: JSON.parse(address.rawAddress ?? '{}'),
		};
	}
}
